import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ErrorCodeTitle from "./ErrorCodeTitle";
import { fonts } from "theme";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        errorCode: {
            color: theme.palette.secondary.main,
            "-webkit-text-stroke": `4px ${theme.palette.common.black}`,
            fontFamily: fonts.secondary,
            fontWeight: 900,
        },
    });
});

interface IProps {
    errorCode: number;
}

export default function ErrorCodeComponent(props: IProps) {
    const classes = useStyles();
    const { errorCode } = props;

    if (errorCode === 404) return <ErrorCodeTitle code={errorCode} />;

    return (
        <Typography variant="h2" className={classes.errorCode}>
            {errorCode}
        </Typography>
    );
}
